// pasul din stepper-ul studentului:
// 0 = profil, 1 = solicitare, 2 = incarcare cerere, 3 = descarcare cerere semnata
export const profilComplet = (student) =>
  !!(student && student.grupa && student.an && student.id_specializare && student.an_inmatriculare && student.telefon);

// inchisa = platforma s-a inchis: nu se mai poate modifica nimic, doar descarca
export const pasStudent = (student, cerere, inchisa = false) => {
  if (!student) return 1;
  // dupa inchidere profilul nu mai poate fi completat; pasul de solicitare explica situatia
  if (inchisa && student.e_repartizat !== 1) return 1;
  if (!profilComplet(student)) return 0;
  if (student.e_repartizat !== 1) return 1;
  // dupa inchidere nu se mai incarca nimic: cine are o cerere ajunge direct la descarcare
  if (inchisa) return cerere ? 3 : 2;
  // daca profesorul a cerut modificari, studentul se intoarce la incarcare
  if (cerere && !cerere.mesaj_modificari) return 3;
  return 2;
};
